import type { ParsedUrlQueryInput } from 'querystring';
import qs from 'querystring';

export const toString = (params: ParsedUrlQueryInput, prefix = '?'): string => {
  const queryStr = qs.stringify(params);

  return queryStr ? prefix + queryStr : '';
};
